module.exports = __webpack_public_path__ + "img/dfk.14062980.png";